import { render, staticRenderFns } from "./bandeja-aprobacion.vue?vue&type=template&id=2b78f473&scoped=true"
import script from "./bandeja-aprobacion.vue?vue&type=script&lang=js"
export * from "./bandeja-aprobacion.vue?vue&type=script&lang=js"
import style0 from "./bandeja-aprobacion.vue?vue&type=style&index=0&id=2b78f473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78f473",
  null
  
)

export default component.exports